import React from 'react';
import PropTypes from 'prop-types';
import CircledQuestionMark from 'resources/circled_question_mark.png';
import './CurrencyCardNew.css';

const CurrencyCardNew = ({
  amount,
  label,
  format,
  icon,
  isSapphire,
  setShowInfoModal
}) => {
  const renderAmount = format ? format(amount) : amount;
  return (
    <div className="currency-card-new">
      {isSapphire && (
        <button
          className="sapphire-info-button"
          type="button"
          onClick={() => setShowInfoModal(true)}
        >
          <img src={CircledQuestionMark} alt="Open Sapphire Info Modal" />
        </button>
      )}
      {icon && <img className="currency-icon" src={icon} alt={label} />}
      <div className="currency-label">{label}</div>
      <div className="currency-value">{renderAmount}</div>
    </div>
  );
};

CurrencyCardNew.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  icon: PropTypes.string,
  label: PropTypes.string.isRequired,
  format: PropTypes.func,
  isSapphire: PropTypes.bool,
  setShowInfoModal: PropTypes.func
};

export default CurrencyCardNew;
